import { Upload } from "antd";
import { UploadOutlined, CloseOutlined } from "@ant-design/icons";

function WatermarkUpload({ logo, onLogoUpload, onLogoRemove }) {
  const { Dragger } = Upload;

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => onLogoUpload(img);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div
      style={{
        marginTop: "12px",
      }}
    >
      <label
        className="dimension-label"
        style={{ display: "block", marginBottom: "6px" }}
      >
        Watermark Logo (Optional)
      </label>

      {/* Centered upload box */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: "8px",
            width: "320px",
            background: "#fafafa",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.border = "1px solid #1890ff";
            e.currentTarget.style.background = "#f0f8ff";
          }} // hover effect on upload area
          onMouseLeave={(e) => {
            e.currentTarget.style.border = "1px solid #ddd";
            e.currentTarget.style.background = "#fafafa";
          }}
        >
          {!logo ? (
            <Dragger
              accept="image/*"
              multiple={false}
              showUploadList={false}
              beforeUpload={(file) => {
                handleLogoUpload({ target: { files: [file] } });
                return false;
              }}
              style={{
                borderRadius: "6px",
                padding: "12px 0",
                minHeight: "100px",
              }}
            >
              <p
                className="ant-upload-drag-icon"
                style={{ marginBottom: "4px" }}
              >
                <UploadOutlined style={{ fontSize: "22px", color: "#aaa" }} />
              </p>
              <p className="dimension-label" style={{ marginBottom: "2px" }}>
                Upload your logo
              </p>
              <p
                className="dimension-label"
                style={{ fontSize: "12px", opacity: 0.7 }}
              >
                PNG, JPG, SVG up to 5MB
              </p>
            </Dragger>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={logo.src}
                  alt="Uploaded logo"
                  style={{
                    maxWidth: "150px",
                    maxHeight: "130px",
                    objectFit: "contain",
                    borderRadius: "6px",
                    padding: "4px",
                    background: "#fff",
                  }}
                />
                <CloseOutlined
                  onClick={onLogoRemove}
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                    cursor: "pointer",
                    background: "#f44336",
                    color: "#fff",
                    borderRadius: "50%",
                    padding: "4px",
                    fontSize: "12px",
                    lineHeight: "1",
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default WatermarkUpload;